/**
 * Nombre del contacto "Persona de Contacto" de un lead.
 *  - persona + negocio  -> "Persona (Negocio)"
 *  - solo persona       -> "Persona"
 *  - solo negocio       -> "Negocio (contacto)"
 *  - nada               -> null (no renombrar)
 */
export function computePersonaContactName(personaName, businessName) {
  const persona = (personaName || "").toString().trim();
  const negocio = (businessName || "").toString().trim();
  if (persona && negocio) return `${persona} (${negocio})`;
  if (persona) return persona;
  if (negocio) return `${negocio} (contacto)`;
  return null;
}
